var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccountAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C21.6266 12 19.3066 12.7038 17.3332 14.0224C15.3598 15.3409 13.8217 17.2151 12.9135 19.4078C12.0052 21.6005 11.7676 24.0133 12.2306 26.3411C12.6936 28.6689 13.8365 30.8071 15.5147 32.4853C17.193 34.1635 19.3311 35.3064 21.6589 35.7694C23.9867 36.2325 26.3995 35.9948 28.5922 35.0865C30.7849 34.1783 32.6591 32.6402 33.9776 30.6668C35.2962 28.6934 36 26.3734 36 24C36 20.8174 34.7357 17.7651 32.4853 15.5147C30.2348 13.2643 27.1826 12 24 12ZM30.548 33.446C30.548 33.5261 30.5277 33.6048 30.4888 33.6748C30.45 33.7448 30.3939 33.8037 30.326 33.846C28.4478 35.0817 26.2488 35.7402 24.0005 35.7402C21.7523 35.7402 19.5532 35.0817 17.675 33.846C17.6071 33.8036 17.5511 33.7446 17.5123 33.6747C17.4735 33.6047 17.4531 33.526 17.453 33.446V31.052C17.4531 29.6622 17.8952 28.3084 18.7155 27.1865C19.5358 26.0646 20.6917 25.2326 22.016 24.811C21.1543 24.3662 20.4671 23.6447 20.0647 22.7624C19.6622 21.8802 19.5679 20.8883 19.7967 19.946C20.0256 19.0036 20.5645 18.1655 21.3268 17.5662C22.0892 16.9669 23.0308 16.6411 24.0005 16.6411C24.9702 16.6411 25.9118 16.9669 26.6742 17.5662C27.4365 18.1655 27.9754 19.0036 28.2043 19.946C28.4332 20.8883 28.3388 21.8802 27.9363 22.7624C27.5339 23.6447 26.8467 24.3662 25.985 24.811C27.3093 25.2326 28.4652 26.0646 29.2855 27.1865C30.1058 28.3084 30.5479 29.6622 30.548 31.052V33.446Z",
    stroke: "#777777",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_10",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_10"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_10",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountAdmin);
export default __webpack_public_path__ + "static/media/my_account_admin.86e1f3efcbf4e787a5ac5a029eb7ca40.svg";
export { ForwardRef as ReactComponent };